import React from "react";
import Carousel, { Dots } from "@brainhubeu/react-carousel";

import { NextIcon, PreviousIcon } from "./icons/ImageSlider";
import TopOfferCard from "./cards/TopOfferCard";

class TopOfferCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
    };
  }

  onChange = value => this.setState({ value })

  render() {
    const { topOffers } = this.props;
    const slides = topOffers.map(
      ({
        offerUrl,
        brand,
        title,
        subtitle,
        imageUrl,
        leasingOffer,
        isNewCar,
        isBusinessOnly,
        ...rest
      }) => (
        <TopOfferCard
          key={offerUrl}
          brand={brand}
          title={title}
          subtitle={subtitle}
          offerUrl={offerUrl}
          imageUrl={imageUrl}
          imageAlt={title}
          leasingOffer={leasingOffer}
          isNewCar={isNewCar}
          isBusinessOnly={isBusinessOnly}
          {...rest}
        />
      ),
    );

    return (
      <>
        <Carousel
          value={this.state.value}
          onChange={this.onChange}
          keepDirectionWhenDragging
          infinite
          slides={slides}
          slidesPerPage={4}
          slidesPerScroll={1}
          addArrowClickHandler
          arrowLeft={(
            <div className="custom-arrow-base">
              <PreviousIcon color="grey" hoverColor="grey-dark" />
            </div>
          )}
          arrowRight={(
            <div className="custom-arrow-base">
              <NextIcon color="grey" hoverColor="grey-dark" />
            </div>
          )}
          breakpoints={{
            991: {
              // these props will be applied when screen width is less than 992px
              slidesPerPage: 3,
              slidesPerScroll: 1,
            },
            767: {
              // these props will be applied when screen width is less than 768px
              slidesPerPage: 2,
              slidesPerScroll: 1,
            },
            575: {
              // these props will be applied when screen width is less than 576px
              slidesPerPage: 1,
              slidesPerScroll: 1,
            },
          }}
        />
        <Dots
          value={this.state.value}
          onChange={this.onChange}
          number={slides.length}
        />
      </>
    );
  }
}

export default TopOfferCarousel;
